import { io } from "socket.io-client";

const SOCKET_URL = "https://wavetechservices.in"; // Replace with your backend URL

export const socket = io(SOCKET_URL, {
  transports: ["websocket"], // Ensures real-time data exchange
  forceNew: true,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 500,
});
